module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.372d0cc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.ttf
// module id = 3Ny9
// module chunks = 10